// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "12449b5990387ae1ff52bafe5c619bed" + ".js";
};